import React, { useState, useEffect, useRef } from "react";
import "./editbanners.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { resolvePath, useNavigate } from "react-router-dom";
import { decode } from "base-64";
import { HiMenu, HiX } from "react-icons/hi";
import { useParams } from "react-router-dom";
import { UpdateBannerImageAction, BannerImageDetailAction } from "../../actions/bannerAction";
import { notify } from '../../services/notification';
import { useDispatch } from "react-redux";
import Validation from "../../constants/validation/Validation";
import useMobileView from "../../constants/useMobileView";
import Cookies from 'js-cookie';
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";

function EditBanners() {
  const [states, setStates] = useState({
    name: "",
    banner_type: "",
    redirect_url: "",
    banner_image: "",
    start_date: "",
    end_date: "",
  })
  const [selectedImage, setSelectedImage] = useState(null);
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const [previewImageSrc, setPreviewImageSrc] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setloading] = useState(false);
  const { id } = useParams();
  const banner_id = decode(id);
  const fileInputRefs = useRef(null);
  const BannerType = ["Top", "Bottom"];
  const today = new Date().toISOString().split("T")[0];
  var vehicleType = Cookies.get('vehicletype') ? Cookies.get('vehicletype') : "";
  if (vehicleType) {
    vehicleType = decode(vehicleType)
  }
  const is3w = () => {
    return vehicleType == "3W"
  };

  useEffect(() => {
    getBannerDetailData();
  }, []);



  const onCloseButtonClick = () => {
    navigate('/banners')
  }

  const handleBannerTypeChange = (event) => {
    const selectedType = event.target.value
    setStates({ ...states, banner_type: selectedType });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const previewImageSrc = reader.result;
        setPreviewImageSrc(previewImageSrc);
        setSelectedImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };



  async function getBannerDetailData() {
    setloading(true);
    var response = await dispatch(BannerImageDetailAction(banner_id));
    if (response == 200 || response != null) {
      setStates({
        name: response.data.data.name,
        banner_type: response.data.data.banner_type,
        redirect_url: response.data.data.redirect_url,
        banner_image: response.data.data.banner_image_url,
        start_date: response?.data?.data?.start_date,
        end_date: response?.data?.data?.end_date,
      })
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }

  }

  const handleOnUpdateClick = async (e) => {
    e.preventDefault();
    // const urlValidationRegex = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,})(\/[\w .-]*)*\/?$/i;
    // if (states.redirect_url && !urlValidationRegex.test(states.redirect_url)) {
    //   notify.error("Invalid URL entered");
    //   return false;
    // }
    // Validate required fields
    if (!states.name || !states.banner_type || (!selectedImage && !states.banner_image)) {
      notify.error("Please fill in all required fields");
      return false;
    }

    // Validate date fields for 3W users
    if (is3w()) {
      if (!states.start_date || !states.end_date) {
        notify.error("Date fields are required for 3W users");
        return false;
      }

      // Validate that end_date is after start_date
      if (new Date(states.end_date) <= new Date(states.start_date)) {
        notify.error("To Date must be after From Date");
        return false;
      }
    }

    setloading(true);
    const apiReq = {
      name: states.name,
      redirect_url: states.redirect_url,
      banner_type: states.banner_type.toLowerCase(),
    }
    // Include date fields for 3W users
    if (is3w()) {
      apiReq.start_date = states.start_date;
      apiReq.end_date = states.end_date;
    }
    if (selectedImage) {
      apiReq.banner_image = selectedImage;
    }
    let response = await dispatch(UpdateBannerImageAction(apiReq, banner_id));
    if (response?.status === 200) {
      notify.success(response.data?.msg)
      setloading(false);
      navigate("/banners")
    } else if (response === undefined) {
      setloading(false);
    }
  }

  // Determine if the save button should be disabled
  const isSaveDisabled = () => {
    const basicRequirements = !states.name || (!selectedImage && !states.banner_image) || !states.banner_type;

    // Add date validation for 3W users
    if (is3w()) {
      return basicRequirements || !states.start_date || !states.end_date;
    }

    return basicRequirements;
  };
  
  return (
    <div className="edit-banners-container">
      <div className="banners-container-right">
        <Header title="Edit Banners" />
        <div className="banners-container-edit">
          {isLoading ? (
            <Loader />
          ) : (
            <form>
              <div className="grid">
                <label className="label-create-banners">Select Banner Type</label>
                <select
                  value={states.banner_type}
                  onChange={handleBannerTypeChange}
                  className="create-banners-input"
                >
                  <option value="">Select banner type</option>
                  {BannerType.map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="grid">
                <label className="label-edit-banners">Title</label>
                <input
                  className="create-banners-input"
                  type="text"
                  name="name"
                  value={states.name}
                  onChange={handleChange}
                />
              </div>
              {is3w() &&
                (
                  <>
                    <div className="grid date">
                      <label className="label-create-banners">From Date</label>
                      <input
                        className="create-banners-input"
                        type="date"
                        id="date"
                        placeholder="dd/mm/yy"
                        name="start_date"
                        min={today}
                        value={states.start_date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="grid date">
                      <label className="label-create-banners">To Date</label>
                      <input
                        className="create-banners-input"
                        type="date"
                        id="date"
                        placeholder="dd/mm/yy"
                        name="end_date"
                        min={today}
                        value={states.end_date}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )
              }
              <div className="grid">
                <label className="label-create-banners">Image Upload</label>
                <label
                  onChange={handleImageUpload}
                  htmlFor="banner_image"
                  className="image-upload-label"
                >
                  <input
                    type="file"
                    className="create-banners-input"
                    name="banner_image"
                    id="banner_image"
                    accept="image/*"
                    hidden
                    ref={fileInputRefs}
                    onChange={handleImageUpload}
                  />
                  Choose File
                </label>
              </div>
              <span className="banner_image_message">The image size should  be 1000*600</span>
              {selectedImage ? (
                <div className="uploaded-img">
                  <img src={previewImageSrc} className="edit-banners-upload" alt="Preview" height="100px" width="100px" />
                  {/* <p>Selected Image: {selectedImage.name}</p> */}
                </div>
              ) :
                (
                  <div className="uploaded-img">
                    <img src={states.banner_image} className="edit-banners-upload" alt="Preview" height="100px" width="100px" />
                    {/* <p>Selected Image: {selectedImage.name}</p> */}
                  </div>
                )
              }
              <div className="grid">
                <label className="label-edit-banners-url">Redirect Url</label>
                <input
                  type="text"
                  className="edit_banners_url"
                  name="redirect_url"
                  value={states.redirect_url}
                  onChange={handleChange}
                />
              </div>
              <div className="btn-edit-banners">
                <button className="edit-banners-active" onClick={onCloseButtonClick}>Close</button>
                <button className="edit-banners-active"
                  disabled={isSaveDisabled()}
                  onClick={handleOnUpdateClick}>Update</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
export default EditBanners;